import AvailableAccountingIntegration from '../model/availableAccountingIntegration'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchAvailableAccountingIntegrations(
  companyID: string
): Promise<RequestResponse<AvailableAccountingIntegration[]>> {
  return secureRequest('GET', url('/v2/availableAccountingIntegrations', { companyID }))
}
